import { render, staticRenderFns } from "./ImagePreviewDialog.vue?vue&type=template&id=0a3d71ca&lang=pug"
import script from "./ImagePreviewDialog.vue?vue&type=script&lang=ts"
export * from "./ImagePreviewDialog.vue?vue&type=script&lang=ts"
import style0 from "./ImagePreviewDialog.vue?vue&type=style&index=0&id=0a3d71ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDialog,VIcon,VImg})
